export default "__VITE_ASSET__ZqA0xz5Q__"